import {CompanyProps} from 'modules/companies/types';
import {OrderStatus, OrderTypeEnum} from '../types';
import colors from './order-status-colors';

interface Props {
  currentStatusName: OrderStatus;
  type: OrderTypeEnum;
  company: CompanyProps;
}

export default ({currentStatusName, company, type}: Props) => {
  if (currentStatusName === OrderStatus.opened) return colors.preparing;
  if (currentStatusName === OrderStatus.preparing && type === 'pickup')
    return colors.ready_to_pickup;
  if (currentStatusName === OrderStatus.preparing && type === 'delivery')
    return colors.ready_to_delivery;
  if (currentStatusName === OrderStatus.ready_to_delivery)
    return colors.delivering;
  if (currentStatusName === OrderStatus.delivering && company.deliveryByCompany)
    return colors.finished;
  if (
    currentStatusName === OrderStatus.delivering &&
    !company.deliveryByCompany
  )
    return colors.arrival;
  if (currentStatusName === OrderStatus.arrival) return colors.finished;
  if (currentStatusName === OrderStatus.ready_to_pickup) return colors.finished;
};
